import React, { useContext } from "react";

import { SingleBuildingContext } from "../../context/AddSingleBuildingContext";
import { STEP } from "../../model/constants";
import { ActionButtons } from "./ActionButtons";
import { ActionInfoModal } from "./ActionInfoModal";
import { useActionLogic } from "./hooks/useActionLogic";

export const Action = () => {
  const { actionButtonsProps, modalActionButton, submitInfo, submitModalOpen } = useActionLogic();

  const { stepNo } = useContext(SingleBuildingContext);
  const isFinalStep = stepNo === STEP.final;

  if (isFinalStep) return;
  return (
    <>
      <ActionInfoModal modalActionButton={modalActionButton} open={submitModalOpen} submitInfo={submitInfo} />
      <ActionButtons {...actionButtonsProps} />
    </>
  );
};
